import { ContextMenuItem } from "lib/@components/context-menu-bar/context-menu-item"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { useDialog } from "lib/@hooks/useDialog"
import { arrayMoveInPlace } from "lib/ArrayMoveInPlace"
import { indexAuthoringTasksInSchedule } from "authoring/routes/project/schedule-editor/lib/index-authoring-tasks-in-schedule"
import { TaskListRefresh } from "event-definitions"
import { MoveToPositionDialog } from "./move-to-position-dialog"

export function MoveToPosition() {
    const { target: task, schedule, refresh } = useBoundContext()
    const moveTaskDialog = useDialog(<MoveToPositionDialog />)
    const isHeader = Boolean(task?.isHeader)
    const label = isHeader ? "Move header to position" : "Move to position"

    return <ContextMenuItem icon="line-md:double-arrow-vertical" label={label} onClick={handleMoveTask} />

    async function handleMoveTask() {
        const tasks = schedule?.tasks ?? []
        const candidateTasks = isHeader ? tasks : tasks.filter(isNotHeader)
        const selectedTask = await moveTaskDialog({ tasks: candidateTasks, currentTask: task })
        if (!selectedTask) return

        const fromIndex = tasks.findIndex(matchesCurrentTask)
        const toIndex = tasks.findIndex(matchesSelectedTask)
        if (fromIndex < 0 || toIndex < 0 || fromIndex === toIndex) return

        arrayMoveInPlace(tasks, fromIndex, toIndex)
        schedule.tasks = tasks
        indexAuthoringTasksInSchedule(schedule)
        TaskListRefresh.raise()
        refresh()

        function isNotHeader(candidate) {
            return !candidate.isHeader
        }

        function matchesCurrentTask(candidate) {
            return candidate === task
        }

        function matchesSelectedTask(candidate) {
            return candidate === selectedTask
        }
    }
}
